"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
const api_1 = require("@react-google-maps/api");
const react_1 = __importDefault(require("react"));
const google_maps_api_provider_1 = require("../google-maps-api-provider");
const MapMarker_1 = require("./MapMarker");
const MapView_constants_1 = require("./MapView.constants");
const MapView_styles_1 = require("./MapView.styles");
const SpotlightOverlay_1 = require("./SpotlightOverlay");
const MapView = ({ isDisabled, center = MapView_constants_1.MAP_VIEW_CENTER_POSITION, height = MapView_constants_1.DEAFAULT_MAP_VIEW_HEIGHT, children, onLoad, onDragEnd, onDragStart, mapProps, onZoomChanged, onCenterChanged, onIdle, }) => {
    const { isLoaded } = (0, google_maps_api_provider_1.useGoogleApi)();
    if (!isLoaded) {
        return null;
    }
    return (react_1.default.createElement(MapView_styles_1.GoogleMapWrapper, { height: height },
        react_1.default.createElement(api_1.GoogleMap, { onIdle: onIdle, onLoad: onLoad, onDragEnd: onDragEnd, onDragStart: onDragStart, onZoomChanged: onZoomChanged, onCenterChanged: onCenterChanged, center: center, mapContainerStyle: {
                width: "100%",
                height: "100%",
                borderRadius: "inherit",
            }, options: { ...MapView_constants_1.MAP_VIEW_DEFAULT_OPTIONS, gestureHandling: isDisabled ? "none" : "auto", ...mapProps } }, children)));
};
exports.MapView = MapView;
exports.MapView.Marker = MapMarker_1.MapMarker;
exports.MapView.SpotlightOverlay = SpotlightOverlay_1.SpotlightOverlay;
//# sourceMappingURL=MapView.js.map